// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Reader_Class from "../Control.Monad.Reader.Class/index.js";
import * as Control_Monad_Reader_Trans from "../Control.Monad.Reader.Trans/index.js";
import * as Control_Monad_Trans_Class from "../Control.Monad.Trans.Class/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Restaumatic_Menu_Promotions from "../Restaumatic.Menu.Promotions/index.js";
import * as Restaumatic_Promotions_Types_Id from "../Restaumatic.Promotions.Types.Id/index.js";
import * as Restaumatic_PromotionsEngine_Promotions_Promotion from "../Restaumatic.PromotionsEngine.Promotions.Promotion/index.js";
var MenuQuery = function (x) {
    return x;
};
var runMenuQuery = function (menu) {
    return function (v) {
        return Control_Monad_Reader_Trans.runReaderT(v)(menu);
    };
};
var monadMenuQuery = /* #__PURE__ */ Control_Monad_Reader_Trans.monadReaderT(Data_Either.monadEither);
var menuError = /* #__PURE__ */ (function () {
    var $19 = Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(Data_Either.monadEither);
    return function ($20) {
        return MenuQuery($19(Data_Either.Left.create($20)));
    };
})();
var functorMenuQuery = /* #__PURE__ */ Control_Monad_Reader_Trans.functorReaderT(Data_Either.functorEither);
var context = function (msg) {
    return function (v) {
        return Control_Monad_Reader_Trans.mapReaderT(Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(function (x) {
            return msg(Data_Unit.unit) + (": " + x);
        }))(v);
    };
};
var bindMenuQuery = /* #__PURE__ */ Control_Monad_Reader_Trans.bindReaderT(Data_Either.bindEither);
var askMenu = /* #__PURE__ */ Control_Monad_Reader_Class.ask(/* #__PURE__ */ Control_Monad_Reader_Trans.monadAskReaderT(Data_Either.monadEither));
var applyMenuQuery = /* #__PURE__ */ Control_Monad_Reader_Trans.applyReaderT(Data_Either.applyEither);
var applicativeMenuQuery = /* #__PURE__ */ Control_Monad_Reader_Trans.applicativeReaderT(Data_Either.applicativeEither);
var orError = function (v) {
    return function (v1) {
        if (v instanceof Data_Maybe.Just) {
            return Control_Applicative.pure(applicativeMenuQuery)(v.value0);
        };
        if (v instanceof Data_Maybe.Nothing) {
            return menuError(v1(Data_Unit.unit));
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.Query (line 41, column 1 - line 41, column 67): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var findFODPromotion = /* #__PURE__ */ (function () {
    var isFod = function ($21) {
        return Restaumatic_PromotionsEngine_Promotions_Promotion.isFirstOrderPromotion(Restaumatic_Menu_Promotions.toEnginePromotion($21));
    };
    return Control_Bind.bind(bindMenuQuery)(askMenu)(function (v) {
        return orError(Data_Foldable.find(Data_Map_Internal.foldableMap)(isFod)(v.promotions))(function (v1) {
            return "New FOD not found";
        });
    });
})();
var findPromotion = function (id) {
    return Control_Bind.bind(bindMenuQuery)(askMenu)(function (v) {
        return orError(Data_Map_Internal.lookup(Restaumatic_Promotions_Types_Id.ordPromotionId)(id)(v.promotions))(function (v1) {
            return "New promotion not found: " + Data_Show.show(Restaumatic_Promotions_Types_Id.showPromotionId)(id);
        });
    });
};
export {
    findPromotion,
    findFODPromotion,
    askMenu,
    runMenuQuery,
    orError,
    menuError,
    functorMenuQuery,
    applyMenuQuery,
    applicativeMenuQuery,
    bindMenuQuery,
    monadMenuQuery
};
//# sourceMappingURL=index.js.map
